import { IStatusConfig } from '../../../components/StatusBadge'
import { ITabDef } from '../../../helpers/tabErrorUtils'
import { JobPositionListField, JobPositionStatus, OrganizationalLevel } from '../../../services/JobPosition/types'

/** Status of a job role. Local on purpose: a set that belongs to this screen only. */
export const JOB_POSITION_STATUS: Record<JobPositionStatus, IStatusConfig> = {
  active: { label: 'Ativo', colorScheme: 'green' },
  inactive: { label: 'Desativado', colorScheme: 'gray' }
}

export const ORGANIZATIONAL_LEVEL_LABELS: Record<OrganizationalLevel, string> = {
  estrategico: 'Estratégico',
  tatico: 'Tático',
  operacional: 'Operacional'
}

export const ORGANIZATIONAL_LEVEL_OPTIONS = (Object.keys(ORGANIZATIONAL_LEVEL_LABELS) as OrganizationalLevel[]).map(
  (level) => ({ value: level, label: ORGANIZATIONAL_LEVEL_LABELS[level] })
)

// Same limits as the API (JobPositionCreate).
export const LIST_MAX_ITEMS = 50
export const LIST_ITEM_MAX_LENGTH = 500
export const DOCUMENTS_MAX = 50
export const DOCUMENT_NAME_MAX_LENGTH = 255
export const DESCRIPTION_MAX_LENGTH = 20000

export const LIST_FIELD_LABELS: Record<JobPositionListField, string> = {
  duties: 'Descrição Detalhada das Funções',
  education: 'Formação Educacional',
  experience: 'Experiência Profissional',
  skills: 'Conhecimentos e Habilidades'
}

/** The four lists of a role's description, in the order the forms show them. */
export const LIST_FIELDS = Object.keys(LIST_FIELD_LABELS) as JobPositionListField[]

export const JOB_POSITION_TAB_DEFS: ITabDef[] = [
  {
    key: 'general',
    label: 'Informações Gerais',
    fields: ['name', 'sector_id', 'organizational_level', 'duties', 'description']
  },
  {
    key: 'requirements',
    label: 'Requisitos e Qualificações',
    fields: ['education', 'experience', 'skills', 'graduation_ids']
  },
  { key: 'documents', label: 'Documentos Exigidos', fields: ['documents'] }
]
